// @ts-nocheck
/* eslint-disable */
(function() {
	const SORTABLE_DEFAULT_OPTIONS = {
		handle: "li",
		touchHandle: "",
		item: "li",
		placeholder: "placeholder",
		placeholderNodeType: "li",
		attr: "data-sortable-order",
		scrollArea: 0,
		scrollWait: 100,
		scrollStep: 10,
		clickDistance: 3
	};

	class Sortable {
		constructor(list, options) {
			// objekt s konfiguraci
			this._options = Object.assign({}, SORTABLE_DEFAULT_OPTIONS, options);
			// rodicovsky element, ve kterem se daji tahat primi potomci
			this._list = list;
			// element, ktery scrolluje, pokud ma list moc polozek - muze a nemusi to byt sam list
			this._scroll = list;
			// vyska listu
			this._listHeight = 0;
			// vyska jednoho itemu
			this._itemHeight = 0;
			// taha se nebo jen klika?
			this._drag = false;
			// pretahovany potomek listu
			this._draggedItem = null;
			// placeholder, ktery zabira misto tam, kam dopadne po upusteni draggedItem
			this._placeholder = document.createElement(this._options.placeholderNodeType);
			this._placeholder.classList.add(this._options.placeholder);
			// nejake pocatecni hodnoty pri down potrebne pozdeji pri move
			this._origin = {
				clientX: 0,
				clientY: 0,
				translateY: 0,
				scrollTop: 0
			};
			// posledni pozice mysi, aby bylo z ceho pocitat rozdil
			this._lastClientY = 0;
			// interval pro scrollovani
			this._interval = null;
			// je zrovna povoleno tahat?
			this._enabled = false;
			this._wasMove = false;
			this._selAttr = -1;

			this._list.classList.add("sortable");
			this._list.addEventListener("pointerdown", this, false);

			this.enabled = true;

		}

		destroy() {
			this.enabled = false;
			this._list.removeEventListener("pointerdown", this, false);
		}

		set options(options) {
			this._options = Object.assign({}, SORTABLE_DEFAULT_OPTIONS, options);
		}

		/**
		 * Zakazani/povoleni presunovani.
		 *
		 * @param {Boolean} state Novy stav
		 */
		set enabled(state) {
			this._enabled = state;

			if (state) {
				this._list.setAttribute("touch-action", "pan-y");
				this._list.style.touchAction = "pan-y";
			}
			else {
				this._list.removeAttribute("touch-action");
				this._list.style.removeProperty("touchAction");
			}
		}

		/**
		 * Ziskani stavu.
		 *
		 * @return {Boolean}
		 */
		get enabled() {
			return this._enabled;
		}

		reConf() {
			let index = 0;
			let dragged = null;
			Array.from(this._list.childNodes).forEach(node => {
				if (!node.classList.contains("placeholder")) {
					if (node.classList.contains("dragged")) {
						dragged = node;
					}

					if (!node.hasAttribute(this._options.attr)) {
						node.setAttribute(this._options.attr, index);
					}
					index++
				}
			});
			if (dragged) {
				dragged.parentNode.appendChild(dragged);
			}

			this._clearInterval();
			this._listHeight = parseFloat(getComputedStyle(this._list).getPropertyValue("height"));
		}

		handleEvent(e) {
			switch (e.type) {
				case "pointerdown":
					// u mysi chceme pouze leve tlacitko
					if (e.pointerType == "mouse" && e.buttons != 1) return;
					this._pointerdown(e);
					break;

				case "pointerup":
				case "pointercancel":
					this._pointerup(e);
					break;

				case "pointermove":
					this._pointermove(e);
					break;
			}
		}

		_pointerdown(e) {
			this._wasMove = false;

			document.addEventListener("pointerup", this, false);

			let handle = e.target.closest(this._options.touchHandle && e.pointerType != "mouse" ? this._options.touchHandle : this._options.handle);

			this._draggedItem = (handle || e.target).closest(this._options.item);
			this._origin.clientX = e.clientX;
			this._origin.clientY = e.clientY;

			if (!handle || !this._enabled) return;

			document.addEventListener("pointermove", this, false);

			this._drag = true;

			e.preventDefault();
			this._list.setAttribute("touch-action", "none");
			this._list.style.touchAction = "none";

			let translateY = 0;

			// najdeme prvniho rodice, co scrolluje a toho si zapamatujeme
			this._scroll = this._list;

			while (this._scroll != document.body) {
				if (this._scroll.scrollHeight > this._scroll.clientHeight) {
					break;
				}
				this._scroll = this._scroll.parentNode;
			}

			let styles = getComputedStyle(this._draggedItem);
			let transform = styles.getPropertyValue("transform");

			this._itemHeight = parseFloat(styles.getPropertyValue("height"));

			if (transform) {
				let parts = transform.split("(");
				if (parts.length >= 2) {
					let nums = parts[1].split(",").map(i => parseFloat(i));
					switch (parts[0].toLowerCase()) {
						case "matrix":
							translateY = nums[5];
							break;

						case "matrix3d":
							translateY = nums[13];
							break;
					}
				}
			}

			this._origin.translateY = translateY;
			this._origin.scrollTop = this._scroll.scrollTop;
		}

		_pointermove(e) {
			if (!this.enabled) return;

			e.preventDefault();

			let clientY = e.clientY;

			if (!this._drag) { return; }

			if (!this._wasMove) {
				let distance = this._distance(e.clientX, clientY, this._origin.clientX, this._origin.clientY);

				if (distance >= this._options.clickDistance) {
					Array.from(this._list.childNodes).forEach((node, index) => node.setAttribute(this._options.attr, index));
					this._selAttr = parseInt(this._draggedItem.getAttribute(this._options.attr));
					this._draggedItem.style.transform = "translate3d(0, " + this._origin.translateY + "px, 0)";
					this._draggedItem.classList.add("dragged");
					this._list.insertBefore(this._placeholder, this._draggedItem);
					this._list.appendChild(this._draggedItem);
					this._listHeight = parseFloat(getComputedStyle(this._list).getPropertyValue("height"));
					document.body.classList.add("dragging");
					this._list.dispatchEvent(new CustomEvent("sortable-start"));
					this._wasMove = true;
				}
				else {
					return;
				}
			}

			this._draggedItem.style.transform = "translate3d(0, " + Math.min(this._listHeight - this._itemHeight, Math.max(0, this._origin.translateY + clientY - this._origin.clientY - this._origin.scrollTop + this._scroll.scrollTop)) + "px, 0)";
			this._draggedItem.style.display = "none";

			let elm = document.elementFromPoint(this._origin.clientX, clientY);

			this._draggedItem.style.removeProperty("display");

			if (this._list.contains(elm)) {
				elm = elm ? elm.closest(this._options.item) : null;
				if (elm && !elm.classList.contains(this._options.placeholder)) {
					if (this._lastClientY - clientY < 0) {
						this._list.insertBefore(this._placeholder, elm.nextSibling);
					} else if (this._lastClientY - clientY > 0) {
						this._list.insertBefore(this._placeholder, elm);
					}
					this._list.dispatchEvent(new CustomEvent("sortable-move", {detail: {placeholder: this._placeholder}}));
				}
			}

			if (this._options.scrollArea > 0) {
				let rect = this._scroll.getBoundingClientRect();

				// scrollovat nahoru
				if (e.pageY - rect.top < this._options.scrollArea) {
					this._setInterval(clientY, -1);
				// scrollovat dolu
				} else if (rect.top + rect.height - e.pageY < this._options.scrollArea) {
					this._setInterval(clientY, 1);
				}
				else {
					this._clearInterval();
				}
			}

			this._lastClientY = clientY;
		}

		_pointerup(e) {
			if (this._enabled) {
				this._clearInterval();

				document.removeEventListener("pointermove", this, false);
			}

			document.removeEventListener("pointerup", this, false);

			this._list.setAttribute("touch-action", "pan-y");
			this._list.style.touchAction = "pan-y";

			// pohyb
			if (this._wasMove) {
				document.body.classList.remove("dragging");
				this._draggedItem.classList.remove("dragged");
				this._list.insertBefore(this._draggedItem, this._placeholder);
				this._placeholder.remove();
				this._draggedItem.style.removeProperty("transform");

				let order = [];
				let toIndex = -1;

				Array.from(this._list.childNodes).forEach((node, ind) => {
					let nodeId = parseInt(node.getAttribute(this._options.attr));

					if (nodeId == this._selAttr) {
						toIndex = ind;
					}

					order.push(nodeId);
				});

				this._list.dispatchEvent(new CustomEvent("sortable-end", {
					detail: {
						order,
						fromIndex: this._selAttr,
						toIndex
					}
				}));
			}
			else if (this._draggedItem && this._distance(e.clientX, e.clientY, this._origin.clientX, this._origin.clientY) <= this._options.clickDistance) {
				// kliknuti
				this._list.dispatchEvent(new CustomEvent("sortable-click", {
					detail: {
						item: this._draggedItem,
						target: e.target
					}
				}));
			}

			this._drag = false;
		}

		_distance(x1, y1, x2, y2) {
			return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
		}

		_clearInterval() {
			if (this._interval) {
				clearInterval(this._interval);
				this._interval = null;
			}
		}

		_setInterval(clientY, direction) {
			this._clearInterval();

			this._interval = setInterval(() => {
				this._scroll.scrollTop += direction * this._options.scrollStep;
				this._draggedItem.style.transform = "translate3d(0, " + Math.min(this._listHeight - this._itemHeight, Math.max(0, this._origin.translateY + clientY - this._origin.clientY - this._origin.scrollTop + this._scroll.scrollTop)) + "px, 0)";
			}, this._options.scrollWait);
		}
	}

	Mapy.Sortable = Sortable;
}());
